const NewsCategoryId = {
    // 公告
    NOTICE: 1,
    // 平台资讯
    SELF_NEWS: 2,
    // 网易新闻
    NET_EASE_NEWS: 3
}

export const newsCategoryIdValueEnumMap = new Map([
    [NewsCategoryId.NOTICE, '公告'],
    [NewsCategoryId.SELF_NEWS, '平台资讯'],
    [NewsCategoryId.NET_EASE_NEWS, '网易新闻'],
])

export default NewsCategoryId